/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormField,
  FormItem,
  FormControl,
  Input,
} from "@repo/ui";
import { useNavigate } from "react-router-dom";
import { ExcelRenderer } from "react-excel-renderer";
import { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import sweetAlert from "components/sweet-alert";
import { Label } from "ui/label";
import Loader from "ui/page-loader";
import { useCreateBulkVOSEmployees } from "services/employees";
import moment from "moment";
import { excelTimestampToJSDate } from "pages/tickets/utils";

export default function CreateBulkVoiceOfStaffTickets() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const form = useForm({ defaultValues: { serviceDate: null, file: null } });

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
  } = useCreateBulkVOSEmployees();

  useEffect(() => {
    if (createTicketRes) {
      navigate(-1);
      setTickets([]);
      form.reset();
    }
  }, [createTicketRes]);

  const validateTicketItem = () => {
    return true;
    // return (
    //   item.AssetId && item.ActivityType && item.Category && item.SubCategory
    // );
  };

  const validateAllTickets = (tickets) => {
    for (const item of tickets) {
      if (!validateTicketItem(item)) {
        sweetAlert({
          title: "Invalid Data",
          text: "Required Fields Are Missing In List",
          icon: "error",
        });
        return false;
      }
    }
    return true;
  };

  const onSave = () => {
    if (!validateAllTickets(tickets)) {
      return;
    }
    sweetAlert({
      title: "Operation Confirmation",
      text: `Are you sure you want to complete this operation`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        createTicket({
          employees: tickets.map((elm) => ({
            tgId: elm.tgId,
            employeeName: elm.employeeName,
            designation: elm.designation,
            dateOfJoining: moment
              .utc(elm.dateOfJoining, "DD/MM/YYYY")
              .toISOString(),
            nationality: elm.nationality,
            gender: elm.gender,
            region: elm.region,
            reportingTo: elm.reportingTo,
            camp: elm.camp,
            businessUnit: elm.businessUnit,
            department: elm.department,
            contactNumber: elm.contactNumber,
            email: elm.email,
          })),
        });
      },
    });
  };

  const processExcelData = (rows, field) => {
    setLoading(true);
    const ticketsList = [];
    const keys = rows.shift(); //keys,header

    rows.forEach((elm) => {
      if (!elm || !elm.length) return;

      const _ticket = createSingleTicket(elm, keys);
      ticketsList.push(_ticket);
    });

    const _tickets = ticketsList.map((elm) => ({
      tgId: `${elm.ID}`,
      "S#": `${elm["S#"]}`,
      employeeName: `${elm["Employee Name"]}`,
      designation: `${elm.Designation}`,
      dateOfJoining: excelTimestampToJSDate(elm.DOJ),
      nationality: `${elm.Nationality}`,
      gender: `${elm.Gender}`,
      region: `${elm.Region}`,
      camp: `${elm.Camp}`,
      businessUnit: `${elm["Business Unit"]}`,
      department: `${elm.Department}`,
      contactNumber: `${elm["Contact Numbers"]}`,
      email: `${elm["Email ID"]}`,
      reportingTo: `${elm["Reporting To"]}`,
    }));
    setLoading(false);
    setTickets(_tickets);
    field.onChange(_tickets);
  };
  const createSingleTicket = (rowData, keys) => {
    const _ticket = {};

    rowData.forEach((item, index) => {
      _ticket[keys[index]] = item;
    });

    keys.forEach((key) => {
      if (_ticket[key] === undefined) {
        _ticket[key] = "";
      }
    });

    return _ticket;
  };

  const handleExcelError = (err) => {
    sweetAlert({ title: "Operation Failure", text: err, icon: "error" });
  };

  const handleFileUploadError = () => {
    sweetAlert({
      title: "File Upload Failed",
      text: "Can Not Upload File",
      icon: "error",
    });
  };

  const fileHandler = (event, field) => {
    if (!event?.target?.files) {
      handleFileUploadError();
      return;
    }

    const fileObj = event.target.files[0];
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        handleExcelError(err);
        return;
      }
      processExcelData(resp.rows, field);
    });
  };

  return (
    <>
      {creatingTicket || loading ? <Loader /> : <></>}

      <Card className="mt-4 overflow-hidden w-full">
        <CardHeader>
          <CardTitle>
            <div className="flex flex-row justify-between w-full gap-2">
              Add Employees
              <Button variant="secondary" onClick={form.handleSubmit(onSave)}>
                Save
              </Button>
            </div>
          </CardTitle>
        </CardHeader>

        <Form {...form}>
          <form className="space-y-8 custom-form-v2">
            <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
              <div className="form-row-d-50 [&>.space-y-2]:!w-full">
                <FormField
                  control={form.control}
                  name="file"
                  rules={{ required: "Please Upload File" }}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="Upload File" isRequired />
                      <FormControl>
                        <div>
                          <Input
                            style={
                              form.formState?.errors?.file
                                ? { borderColor: "red" }
                                : {}
                            }
                            type="file"
                            onChange={(event) => {
                              fileHandler(event, field);
                            }}
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          />
                          {form.formState?.errors?.file ? (
                            <p className="text-destructive text-xs">
                              Please Upload File
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>

              {tickets.length > 0 ? (
                <Grid
                  data={tickets}
                  className="list-tables-v1"
                  style={{ overflow: "hidden" }}
                >
                  <GridColumn title="S#" field="S#" width="120px" />
                  <GridColumn title="ID" field="tgId" width="120px" />
                  <GridColumn
                    title="Employee Name"
                    field="employeeName"
                    width="170px"
                  />
                  <GridColumn
                    title="Designation"
                    field="designation"
                    width="170px"
                  />
                  <GridColumn title="DOJ" field="dateOfJoining" width="200px" />
                  <GridColumn
                    title="Nationality"
                    field="nationality"
                    width="120px"
                  />
                  <GridColumn title="Gender" field="gender" width="120px" />
                  <GridColumn title="Region" field="region" width="120px" />
                  <GridColumn title="Camp" field="camp" width="120px" />
                  <GridColumn
                    title="Business Unit"
                    field="businessUnit"
                    width="120px"
                  />
                  <GridColumn
                    title="Department"
                    field="department"
                    width="150px"
                  />
                  <GridColumn
                    title="Reporting To"
                    field="reportingTo"
                    width="150px"
                  />
                  <GridColumn
                    title="Contact Numbers"
                    field="contactNumber"
                    width="120px"
                  />
                  <GridColumn title="Email ID" field="email" width="300px" />
                </Grid>
              ) : (
                <></>
              )}
            </CardContent>
          </form>
        </Form>
      </Card>
    </>
  );
}
